import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

/** The root query type for Checkout access */
export type Query = {
  __typename?: 'Query';
  availableTickets: Array<CheckoutTicketBlueprint>;
  /** White-label checkout branding for a host, or an explicit unknown-host result */
  branding: CheckoutBranding;
  /** Returns single sellable event details */
  event?: Maybe<CheckoutEvent>;
  orderSummary?: Maybe<OrderSummary>;
  shoppingCart: ShoppingCart;
};


/** The root query type for Checkout access */
export type QueryAvailableTicketsArgs = {
  shoppingCartToken?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type for Checkout access */
export type QueryBrandingArgs = {
  host: Scalars['String']['input'];
};


/** The root query type for Checkout access */
export type QueryEventArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type for Checkout access */
export type QueryOrderSummaryArgs = {
  fingerprint: Scalars['String']['input'];
};


/** The root query type for Checkout access */
export type QueryShoppingCartArgs = {
  eventId: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutTicketBlueprint = {
  __typename?: 'CheckoutTicketBlueprint';
  breakdown?: Maybe<CheckoutBlueprintPriceBreakdown>;
  category?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  maximum?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  multiple?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Use `displayPrice` from `breakdown` */
  price: Scalars['Float']['output'];
  soldOut: Scalars['Boolean']['output'];
  ticketType?: Maybe<Scalars['String']['output']>;
};

export type CheckoutBlueprintPriceBreakdown = {
  __typename?: 'CheckoutBlueprintPriceBreakdown';
  ccFee: Scalars['Float']['output'];
  convenienceFee: Scalars['Float']['output'];
  displayPrice: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  taxFee: Scalars['Float']['output'];
};

/**
 * White-label branding for a checkout host. Always resolves: an unknown host is returned as
 * `known: false` (not a client), which a caller distinguishes from a lookup error (data null
 * with a top-level error).
 *
 */
export type CheckoutBranding = {
  __typename?: 'CheckoutBranding';
  attribution: CheckoutAttribution;
  brandName?: Maybe<Scalars['String']['output']>;
  favicons: Array<CheckoutFavicon>;
  known: Scalars['Boolean']['output'];
  landingUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * The resolved attribution line for a checkout host: `show: false` for none, otherwise render
 * `text`, linking to `url` when present. Resolved server-side so the raw enum stays out of the
 * contract.
 *
 */
export type CheckoutAttribution = {
  __typename?: 'CheckoutAttribution';
  show: Scalars['Boolean']['output'];
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CheckoutFavicon = {
  __typename?: 'CheckoutFavicon';
  rel: Scalars['String']['output'];
  sizes: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CheckoutEvent = {
  __typename?: 'CheckoutEvent';
  artists?: Maybe<Array<PublicAnnounceArtist>>;
  /** URL of the event canonical URL */
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  config: CheckoutConfig;
  description?: Maybe<Scalars['String']['output']>;
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  footerContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  images?: Maybe<Array<AnnounceImage>>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  promoter?: Maybe<Scalars['String']['output']>;
  seatingChartConfig?: Maybe<SeatsioConfig>;
  /** Whether to show the ICE banner for the event */
  showIceBanner?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  support?: Maybe<Scalars['String']['output']>;
  usesSeatingChart?: Maybe<Scalars['Boolean']['output']>;
  venue?: Maybe<PublicVenue>;
};

export type PublicAnnounceArtist = {
  __typename?: 'PublicAnnounceArtist';
  /** @deprecated Use `links` field instead */
  applemusic?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  bandcamp?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  facebook?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  instagram?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  lastfm?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<PublicArtistLink>>;
  name: Scalars['String']['output'];
  /** @deprecated Use `links` field instead */
  songkick?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  spotify?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  twitter?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  website?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  wikipedia?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  youtube?: Maybe<Scalars['String']['output']>;
};

export type PublicArtistLink = {
  __typename?: 'PublicArtistLink';
  url: Scalars['String']['output'];
};

export type CheckoutConfig = {
  __typename?: 'CheckoutConfig';
  accessCode?: Maybe<Scalars['Boolean']['output']>;
  alerts?: Maybe<Array<CheckoutAlertMessage>>;
  checkboxes?: Maybe<Array<CheckoutCheckboxConfig>>;
  discount?: Maybe<Scalars['Boolean']['output']>;
  donation?: Maybe<Scalars['Boolean']['output']>;
  donationButtonText?: Maybe<Scalars['String']['output']>;
  donationDescription?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['ID']['output']>;
  features?: Maybe<Array<CheckoutFeature>>;
  /** @deprecated Hive integration is handled by the backend */
  hiveBrandId?: Maybe<Scalars['String']['output']>;
  includeCcFee?: Maybe<Scalars['Boolean']['output']>;
  includeConvenienceFee?: Maybe<Scalars['Boolean']['output']>;
  includeTaxFee?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Laylo integration is handled by the backend */
  layloKey?: Maybe<Scalars['String']['output']>;
  paymentProcessor?: Maybe<Scalars['String']['output']>;
  processorAccountId: Scalars['String']['output'];
  processorPublicKey?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  quickCheckoutTos?: Maybe<CheckoutCheckboxConfig>;
  requirePhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  tracking?: Maybe<Array<TrackingEntry>>;
};

export type CheckoutAlertMessage = {
  __typename?: 'CheckoutAlertMessage';
  messages?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CheckoutCheckboxConfig = {
  __typename?: 'CheckoutCheckboxConfig';
  description?: Maybe<Scalars['String']['output']>;
  descriptionTitle?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type CheckoutFeature = {
  __typename?: 'CheckoutFeature';
  enabled: Scalars['Boolean']['output'];
  feature: Scalars['String']['output'];
};

export type TrackingEntry = {
  __typename?: 'TrackingEntry';
  conversionLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  provider: TrackingProviderEnum;
  trackingId: Scalars['String']['output'];
};

export enum TrackingProviderEnum {
  /** Facebook Pixel */
  Facebook = 'facebook',
  /** Google Analytics */
  Ga = 'ga',
  /** Reddit Pixel */
  Reddit = 'reddit',
  /** TikTok Pixel */
  TikTok = 'tik_tok'
}

export type AnnounceImage = {
  __typename?: 'AnnounceImage';
  highlighted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  variants?: Maybe<Array<AnnounceImageVariant>>;
  /** @deprecated Use `variants` */
  versions?: Maybe<AnnounceImageVersions>;
};

export type AnnounceImageVariant = {
  __typename?: 'AnnounceImageVariant';
  src: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type AnnounceImageVersions = {
  __typename?: 'AnnounceImageVersions';
  cover?: Maybe<AnnounceImageVersion>;
  thumb?: Maybe<AnnounceImageVersion>;
};

export type AnnounceImageVersion = {
  __typename?: 'AnnounceImageVersion';
  src?: Maybe<Scalars['String']['output']>;
};

export type SeatsioConfig = {
  __typename?: 'SeatsioConfig';
  /** Whether the event can offer best-available seat selection. */
  bestAvailable: Scalars['Boolean']['output'];
  eventKey: Scalars['String']['output'];
  objectWithoutCategorySelectable?: Maybe<Scalars['Boolean']['output']>;
  objectWithoutPricingSelectable?: Maybe<Scalars['Boolean']['output']>;
  publishedThumbnailUrl?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  workspaceKey: Scalars['String']['output'];
};

export type PublicVenue = {
  __typename?: 'PublicVenue';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  /** Venue logo */
  logo?: Maybe<Logo>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `postal_code` instead */
  postal?: Maybe<Scalars['Int']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `timezone` instead */
  timeZone?: Maybe<Scalars['String']['output']>;
};

/** Venue logo */
export type Logo = {
  __typename?: 'Logo';
  /** Logo variants */
  variants?: Maybe<Array<ImageVariant>>;
};

/** Image variant */
export type ImageVariant = {
  __typename?: 'ImageVariant';
  /** Variant URI */
  src: Scalars['String']['output'];
  /** Variant name */
  variant: Scalars['String']['output'];
};

export type OrderSummary = {
  __typename?: 'OrderSummary';
  /** Billing address */
  address?: Maybe<PublicAddress>;
  breakdown?: Maybe<PriceBreakdown>;
  companyName?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<CheckoutCustomer>;
  event: CheckoutEvent;
  fingerprint: Scalars['String']['output'];
  items: Array<OrderTicket>;
  /** Rich-text order confirmation page content; null unless the event account has the feature */
  orderConfirmationContent?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  vatId?: Maybe<Scalars['String']['output']>;
};

export type PublicAddress = {
  __typename?: 'PublicAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
};

export type PriceBreakdown = {
  __typename?: 'PriceBreakdown';
  itemsBreakdown?: Maybe<Array<BreakdownItem>>;
  itemsTotal?: Maybe<Scalars['Float']['output']>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
  totalBreakdown?: Maybe<Array<BreakdownItem>>;
};

export type BreakdownItem = {
  __typename?: 'BreakdownItem';
  amount: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CheckoutCustomer = {
  __typename?: 'CheckoutCustomer';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Customer phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type OrderTicket = {
  __typename?: 'OrderTicket';
  /** Ticket blueprint id; matches the GA4 item_id */
  blueprintId: Scalars['Int']['output'];
  breakdown?: Maybe<ItemBreakdown>;
  discountCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Paper ticket HTML */
  paperTicketHtml?: Maybe<Scalars['String']['output']>;
  seat?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  /** Ticket token */
  token: Scalars['String']['output'];
};

export type ItemBreakdown = {
  __typename?: 'ItemBreakdown';
  basePrice: Scalars['Float']['output'];
  convenienceFee?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type ShoppingCart = {
  __typename?: 'ShoppingCart';
  controlQuantity: Scalars['Int']['output'];
  items?: Maybe<Array<ShoppingCartItem>>;
  lockExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  priceBreakdown: PriceBreakdown;
  /** seats.io hold token used to reserve carted seats; null for non-seated carts */
  seatsioHoldToken?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  /** Total amount in cents */
  total: Scalars['Int']['output'];
};

export type ShoppingCartItem = {
  __typename?: 'ShoppingCartItem';
  amount?: Maybe<Scalars['Float']['output']>;
  breakdown?: Maybe<ItemBreakdown>;
  count?: Maybe<Scalars['Int']['output']>;
  details?: Maybe<Scalars['JSON']['output']>;
  itemId?: Maybe<Scalars['Int']['output']>;
  itemType: ShoppingCartItemTypeEnum;
  name?: Maybe<Scalars['String']['output']>;
  typeHash: Scalars['String']['output'];
};

export enum ShoppingCartItemTypeEnum {
  Discount = 'DISCOUNT',
  Donation = 'DONATION',
  Presale = 'PRESALE',
  SeatTicket = 'SEAT_TICKET',
  Ticket = 'TICKET'
}

export type Mutation = {
  __typename?: 'Mutation';
  acquireLock?: Maybe<AcquireLockPayload>;
  completeOrder?: Maybe<CompleteOrderPayload>;
  createPaymentInformation?: Maybe<CreatePaymentInformationPayload>;
  /** Return the cart-owned seats.io hold token for a seated event, minting it on first use and replacing it (re-holding the carted seats) once it has expired, so checkout can open a manual seats.io session. Returns null without minting for unseated events. */
  mintHoldToken?: Maybe<MintHoldTokenPayload>;
  /**
   * Synchronously recover a "wedged" order -- one whose Stripe PaymentIntent is
   * `succeeded` but whose order is still `awaiting_payment` -- by driving the same
   * ADR-008 D4 heal predicate + attach path as the background reconcile worker
   * (never a second capture). The server re-verifies everything from the client
   * (provenance, ownership, order state under a row lock, and the PaymentIntent's
   * status/amount/currency/refund state); it trusts nothing supplied in the input.
   * Safe to retry: the outcome is idempotent under a terminal-row veto + row lock,
   * and every response carries a machine-readable `error_code` (see its
   * description) stating whether a retry is worthwhile.
   *
   */
  recoverOrder?: Maybe<RecoverOrderPayload>;
  releaseLock?: Maybe<ReleaseLockPayload>;
  saveOrder?: Maybe<SaveOrderPayload>;
  updateOrderEmail?: Maybe<UpdateOrderEmailMutationPayload>;
  updatePaymentInformation?: Maybe<UpdatePaymentInformationPayload>;
  updateShoppingCart?: Maybe<UpdateShoppingCartPayload>;
};


export type MutationAcquireLockArgs = {
  input: AcquireLockInput;
};


export type MutationCompleteOrderArgs = {
  input: CompleteOrderInput;
};


export type MutationCreatePaymentInformationArgs = {
  input: CreatePaymentInformationInput;
};


export type MutationMintHoldTokenArgs = {
  input: MintHoldTokenInput;
};


export type MutationRecoverOrderArgs = {
  input: RecoverOrderInput;
};


export type MutationReleaseLockArgs = {
  input: ReleaseLockInput;
};


export type MutationSaveOrderArgs = {
  input: SaveOrderInput;
};


export type MutationUpdateOrderEmailArgs = {
  input: UpdateOrderEmailMutationInput;
};


export type MutationUpdatePaymentInformationArgs = {
  input: UpdatePaymentInformationInput;
};


export type MutationUpdateShoppingCartArgs = {
  input: UpdateShoppingCartInput;
};

/** Autogenerated input type of AcquireLock */
export type AcquireLockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of AcquireLock. */
export type AcquireLockPayload = {
  __typename?: 'AcquireLockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CompleteOrder */
export type CompleteOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderFingerprint: Scalars['String']['input'];
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CompleteOrder. */
export type CompleteOrderPayload = {
  __typename?: 'CompleteOrderPayload';
  changeToken?: Maybe<ChangeCustomerToken>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * Machine-readable outcome code accompanying every response that carries one.
   * Derived from the outcome source, not from the human-readable message text.
   * CompleteOrder sets it only on `success: false`; RecoverOrder sets it on both
   * `success: true` (`recovered`, `already_completed`) and `success: false`.
   * Each code states whether a client retry is safe:
   *
   * - `lock_expired`: inventory/seat locks expired before completion. Retry is
   *   safe once the locks are re-acquired.
   * - `already_captured`: the order is already completed and its payment already
   *   captured. Do NOT retry -- treat as success and route to confirmation.
   * - `payment_failed`: the card/capture was declined by the gateway. Retry only
   *   with a new or re-authorized payment.
   * - `capture_amount_exceeds_authorization`: the capture would exceed the
   *   authorized amount. Do NOT retry as-is -- re-authorize (SaveOrder) first.
   * - `limits_exceeded`: a per-event or per-blueprint ticket limit was exceeded.
   *   Do NOT retry -- reduce the quantity.
   * - `seats_unavailable`: the selected seats are already booked. Do NOT retry --
   *   select different seats.
   * - `blacklisted`: the customer/order was declined by the venue blacklist
   *   (emitted by SaveOrder, not CompleteOrder). Do NOT retry.
   * - `order_not_editable`: the order is already finalized / not editable
   *   (emitted by SaveOrder). Do NOT retry.
   * - `order_not_completable`: a concurrent request already completed/advanced
   *   this order (detected under a row lock before any capture). Do NOT retry --
   *   treat as already handled and route to confirmation.
   * - `cart_empty`: there is no cart, or the cart was emptied. Do NOT retry --
   *   restart checkout.
   * - `invalid_state`: the order is missing or not in a completable state. Do NOT
   *   blindly retry.
   * - `system_error`: an unexpected/infrastructure failure. Retry may be safe
   *   after a short delay.
   * - `recovered`: RecoverOrder completed the order via the attach path (no new
   *   capture). Do NOT retry -- route to confirmation.
   * - `not_captured`: the PaymentIntent is not `succeeded` (e.g. `requires_capture`
   *   or `canceled`), so there is no captured payment to attach. Do NOT retry until
   *   the PaymentIntent is captured.
   * - `amount_mismatch`: the captured amount/currency does not match the order
   *   total. Do NOT retry -- this needs manual reconciliation.
   * - `already_completed`: the order is already completed (a concurrent path or a
   *   prior recovery finished it). Treat as success and route to confirmation. Do
   *   NOT retry.
   * - `recovery_failed`: recovery could not complete (a transient Stripe read
   *   error, the seated-event gate, a refunded/cancelled/unresolvable payment, or a
   *   failed heal recorded for ops). A single retry after a short delay is safe; if
   *   it persists, await ops.
   *
   */
  errorCode?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  orderSummary?: Maybe<OrderSummary>;
  success: Scalars['Boolean']['output'];
};

export type ChangeCustomerToken = {
  __typename?: 'ChangeCustomerToken';
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type VpError = {
  __typename?: 'VpError';
  /** Full error message */
  message: Scalars['String']['output'];
  /** Path to the field that caused the error, or `base` */
  path?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreatePaymentInformation */
export type CreatePaymentInformationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePaymentInformation. */
export type CreatePaymentInformationPayload = {
  __typename?: 'CreatePaymentInformationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors, if any */
  errors?: Maybe<Array<VpError>>;
  paymentInformation?: Maybe<Array<PaymentInformation>>;
};

export type PaymentInformation = {
  __typename?: 'PaymentInformation';
  eventId: Scalars['Int']['output'];
  paymentIntent?: Maybe<PaymentIntent>;
  paymentProcessor: Scalars['String']['output'];
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  clientSecret: Scalars['String']['output'];
  id: Scalars['String']['output'];
  stripeAccount: Scalars['String']['output'];
};

/** Autogenerated input type of MintHoldToken */
export type MintHoldTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Token of the shopping cart to mint the hold token for. */
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of MintHoldToken. */
export type MintHoldTokenPayload = {
  __typename?: 'MintHoldTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors that prevented minting; the hold token is null when present. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The seats.io hold token, or null for an unseated event or on failure. */
  holdToken?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RecoverOrder */
export type RecoverOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fingerprint of the order to recover. */
  orderFingerprint: Scalars['String']['input'];
  /** Stripe PaymentIntent id the client believes captured the order. */
  paymentIntentId: Scalars['String']['input'];
};

/** Autogenerated return type of RecoverOrder. */
export type RecoverOrderPayload = {
  __typename?: 'RecoverOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * Machine-readable outcome code accompanying every response that carries one.
   * Derived from the outcome source, not from the human-readable message text.
   * CompleteOrder sets it only on `success: false`; RecoverOrder sets it on both
   * `success: true` (`recovered`, `already_completed`) and `success: false`.
   * Each code states whether a client retry is safe:
   *
   * - `lock_expired`: inventory/seat locks expired before completion. Retry is
   *   safe once the locks are re-acquired.
   * - `already_captured`: the order is already completed and its payment already
   *   captured. Do NOT retry -- treat as success and route to confirmation.
   * - `payment_failed`: the card/capture was declined by the gateway. Retry only
   *   with a new or re-authorized payment.
   * - `capture_amount_exceeds_authorization`: the capture would exceed the
   *   authorized amount. Do NOT retry as-is -- re-authorize (SaveOrder) first.
   * - `limits_exceeded`: a per-event or per-blueprint ticket limit was exceeded.
   *   Do NOT retry -- reduce the quantity.
   * - `seats_unavailable`: the selected seats are already booked. Do NOT retry --
   *   select different seats.
   * - `blacklisted`: the customer/order was declined by the venue blacklist
   *   (emitted by SaveOrder, not CompleteOrder). Do NOT retry.
   * - `order_not_editable`: the order is already finalized / not editable
   *   (emitted by SaveOrder). Do NOT retry.
   * - `order_not_completable`: a concurrent request already completed/advanced
   *   this order (detected under a row lock before any capture). Do NOT retry --
   *   treat as already handled and route to confirmation.
   * - `cart_empty`: there is no cart, or the cart was emptied. Do NOT retry --
   *   restart checkout.
   * - `invalid_state`: the order is missing or not in a completable state. Do NOT
   *   blindly retry.
   * - `system_error`: an unexpected/infrastructure failure. Retry may be safe
   *   after a short delay.
   * - `recovered`: RecoverOrder completed the order via the attach path (no new
   *   capture). Do NOT retry -- route to confirmation.
   * - `not_captured`: the PaymentIntent is not `succeeded` (e.g. `requires_capture`
   *   or `canceled`), so there is no captured payment to attach. Do NOT retry until
   *   the PaymentIntent is captured.
   * - `amount_mismatch`: the captured amount/currency does not match the order
   *   total. Do NOT retry -- this needs manual reconciliation.
   * - `already_completed`: the order is already completed (a concurrent path or a
   *   prior recovery finished it). Treat as success and route to confirmation. Do
   *   NOT retry.
   * - `recovery_failed`: recovery could not complete (a transient Stripe read
   *   error, the seated-event gate, a refunded/cancelled/unresolvable payment, or a
   *   failed heal recorded for ops). A single retry after a short delay is safe; if
   *   it persists, await ops.
   *
   */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Human-readable errors, if any. */
  errors?: Maybe<Array<VpError>>;
  /** The recovered order, when recovery succeeded. */
  orderSummary?: Maybe<OrderSummary>;
  /** Whether the order is now completed. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ReleaseLock */
export type ReleaseLockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of ReleaseLock. */
export type ReleaseLockPayload = {
  __typename?: 'ReleaseLockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  shoppingCart?: Maybe<ShoppingCart>;
};

/** Autogenerated input type of SaveOrder */
export type SaveOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerInformation: CustomerInformationInput;
  eventId: Scalars['Int']['input'];
  orderFingerprint?: InputMaybe<Scalars['String']['input']>;
  shoppingCartToken: Scalars['String']['input'];
};

export type CustomerInformationInput = {
  address: AddressInput;
  agreements?: InputMaybe<Array<Agreement>>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  customer: CustomerInput;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type Agreement = {
  key: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type CustomerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveOrder. */
export type SaveOrderPayload = {
  __typename?: 'SaveOrderPayload';
  changeToken?: Maybe<ChangeCustomerToken>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * Machine-readable outcome code accompanying every response that carries one.
   * Derived from the outcome source, not from the human-readable message text.
   * CompleteOrder sets it only on `success: false`; RecoverOrder sets it on both
   * `success: true` (`recovered`, `already_completed`) and `success: false`.
   * Each code states whether a client retry is safe:
   *
   * - `lock_expired`: inventory/seat locks expired before completion. Retry is
   *   safe once the locks are re-acquired.
   * - `already_captured`: the order is already completed and its payment already
   *   captured. Do NOT retry -- treat as success and route to confirmation.
   * - `payment_failed`: the card/capture was declined by the gateway. Retry only
   *   with a new or re-authorized payment.
   * - `capture_amount_exceeds_authorization`: the capture would exceed the
   *   authorized amount. Do NOT retry as-is -- re-authorize (SaveOrder) first.
   * - `limits_exceeded`: a per-event or per-blueprint ticket limit was exceeded.
   *   Do NOT retry -- reduce the quantity.
   * - `seats_unavailable`: the selected seats are already booked. Do NOT retry --
   *   select different seats.
   * - `blacklisted`: the customer/order was declined by the venue blacklist
   *   (emitted by SaveOrder, not CompleteOrder). Do NOT retry.
   * - `order_not_editable`: the order is already finalized / not editable
   *   (emitted by SaveOrder). Do NOT retry.
   * - `order_not_completable`: a concurrent request already completed/advanced
   *   this order (detected under a row lock before any capture). Do NOT retry --
   *   treat as already handled and route to confirmation.
   * - `cart_empty`: there is no cart, or the cart was emptied. Do NOT retry --
   *   restart checkout.
   * - `invalid_state`: the order is missing or not in a completable state. Do NOT
   *   blindly retry.
   * - `system_error`: an unexpected/infrastructure failure. Retry may be safe
   *   after a short delay.
   * - `recovered`: RecoverOrder completed the order via the attach path (no new
   *   capture). Do NOT retry -- route to confirmation.
   * - `not_captured`: the PaymentIntent is not `succeeded` (e.g. `requires_capture`
   *   or `canceled`), so there is no captured payment to attach. Do NOT retry until
   *   the PaymentIntent is captured.
   * - `amount_mismatch`: the captured amount/currency does not match the order
   *   total. Do NOT retry -- this needs manual reconciliation.
   * - `already_completed`: the order is already completed (a concurrent path or a
   *   prior recovery finished it). Treat as success and route to confirmation. Do
   *   NOT retry.
   * - `recovery_failed`: recovery could not complete (a transient Stripe read
   *   error, the seated-event gate, a refunded/cancelled/unresolvable payment, or a
   *   failed heal recorded for ops). A single retry after a short delay is safe; if
   *   it persists, await ops.
   *
   */
  errorCode?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  orderSummary?: Maybe<OrderSummary>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateOrderEmailMutation */
export type UpdateOrderEmailMutationInput = {
  changeToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fingerprint: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateOrderEmailMutation. */
export type UpdateOrderEmailMutationPayload = {
  __typename?: 'UpdateOrderEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  orderSummary?: Maybe<OrderSummary>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdatePaymentInformation */
export type UpdatePaymentInformationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId: Scalars['String']['input'];
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of UpdatePaymentInformation. */
export type UpdatePaymentInformationPayload = {
  __typename?: 'UpdatePaymentInformationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors, if any */
  errors?: Maybe<Array<VpError>>;
  paymentInformation?: Maybe<Array<PaymentInformation>>;
};

/** Autogenerated input type of UpdateShoppingCart */
export type UpdateShoppingCartInput = {
  changes: ShoppingCartInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shoppingCartToken: Scalars['String']['input'];
};

export type ShoppingCartInput = {
  eventId: Scalars['Int']['input'];
  items?: InputMaybe<Array<ShoppingCartItemInput>>;
};

export type ShoppingCartItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
  itemType: ShoppingCartItemTypeEnum;
};

/** Autogenerated return type of UpdateShoppingCart. */
export type UpdateShoppingCartPayload = {
  __typename?: 'UpdateShoppingCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  shoppingCart: ShoppingCart;
  status?: Maybe<Scalars['String']['output']>;
};


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    